
<div [ngClass]="{ 'row' : !fullwidth }">
  <div *ngIf="!fullwidth" class="col-4">
    <label>{{title}}</label>
  </div>

  <div *ngIf="hideUpload || disabled" [ngClass]="{'col-8': !fullwidth }">
    <div class="upload-item" *ngFor="let f of files; let i = index;" >
      {{!hideCheckbox ? (f.checked ? '☑' : '☐') : ''}}&nbsp;&nbsp;&nbsp;
      <a [routerLink]="[]" (click)="downloadFile(f)" draggable="true" (dragstart)="drag($event, f)"><!--target="_blank" [href]="f.url">-->
        <i class="ionicon ion-ios-copy"></i>&nbsp;{{f.name}}
      </a>&nbsp;<a *ngIf="!disabled" (click)="remove(f)" [routerLink]="[]">X</a>
      <div *ngIf="!hideComment">
        <input type="text" class="comment form-control-sm nrk-disabled-background" [ngModel]="f.comment || ''" disabled>
      </div>
      <div *ngIf="additionalFieldLabel">
        <input type="text" class="comment form-control-sm nrk-disabled-background" [placeholder]="additionalFieldLabel" [ngModel]="f.additionalField || ''" disabled>
      </div>
      <div *ngIf="additionalDateLabel">
        <!-- <input type="text" class="comment form-control-sm nrk-disabled-background" [placeholder]="additionalDate" [ngModel]="f.additionalDate || ''" disabled> -->
        <!-- <ngx-form-js-date [title]="additionalDateLabel" [(value)]="$any(f).additionalDate" (valueChange)="completed.emit()" [disabled]="true"></ngx-form-js-date> -->
        <ngx-doc-form-date 
          class="form-control-sm nrk-disabled-background" 
          [(value)]="$any(f).additionalDate" 
          [title]="additionalDateLabel" 
          [disabled]="true"
          style="display:block">
        </ngx-doc-form-date>
      </div>
      <div *ngIf="canShowPreview(f)">
        <ngx-thumb-image [imageUrl]="'/api/v1' + f.url"></ngx-thumb-image>
      </div>
    </div>
  </div>

  <div *ngIf="!hideUpload && !disabled" [ngClass]="{'col-8': !fullwidth }">
    <!-- <div class="col-4" *ngIf="!hideUpload && !disabled"> -->
    <div>
      <div class="drop-container" ngFileDrop [options]="options" (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput">
        <p>
          Drag files here or
          <label class="upload-button">
            <input type="file" ngFileSelect [attr.accept]="this.accept" [options]="options" (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput" multiple>
          </label>
        </p>
      </div>
      <div class="upload-item" *ngFor="let f of uploadFiles; let i = index;">
        <div class="upload-item-content">
          <div class="filename">
            <div class="filename-left">
              <i class="ionicon ion-ios-copy"></i>
              <span>{{ f.name }}</span>
            </div>
            <div class="filename-right">
              <i class="ionicon ion-close-round" (click)="cancelUpload(f.id)"></i>
            </div>
          </div>
          <div class="progress-content">
            <div class="progress">
              <span class="bar" [style.width]="f?.progress?.data?.percentage + '%'" [class.is-done]="f?.progress?.data?.percentage === 100"></span>
            </div>
          </div>
          <div class="progress-text-content">
            <span class="progress-text" [class.is-done]="f?.progress?.data?.percentage === 100">
              <span>{{ f.progress?.data?.percentage }}% </span>
              <span *ngIf="f.progress?.data?.percentage !== 100">Uploading...</span>
              <span *ngIf="f.progress?.data?.percentage === 100">Done</span>
            </span>
            <span class="speed-and-eta-text" *ngIf="f.progress?.data?.percentage !== 0 && f.progress?.data?.percentage !== 100">
              <span>{{ f.progress?.data?.speedHuman }} </span>
              <span>ETA {{ f.progress?.data?.etaHuman }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  
    <div class="upload-item" *ngFor="let f of files; let i = index; last as isLast">
      <table class="w-100">
        <tr><td>
          <input *ngIf="!hideCheckbox" type="checkbox" [ngModel]="f.checked" [attr.disabled]="disabled ? true : null" (ngModelChange)="fileChecked(f)"/>&nbsp;&nbsp;&nbsp;

          <ng-container *ngIf="f.url !== '/files/undefined'">
            <a [routerLink]="[]" (click)="downloadFile(f)" draggable="true" (dragstart)="drag($event, f)"><!--target="_blank" [href]="f.url">-->
              <i class="ionicon ion-ios-copy"></i>&nbsp;&nbsp;{{f.name}}&nbsp;&nbsp;</a>
            <a (click)="remove(f)" [routerLink]="[]" title="delete file">X</a>
          </ng-container>

          <ng-container *ngIf="f.url === '/files/undefined'">
            <span style="color:lightgray">
              <i class="ionicon ion-ios-copy"></i>&nbsp;&nbsp;{{f.name}}&nbsp;&nbsp;</span>
            <a (click)="remove(f)" [routerLink]="[]" title="delete file">X</a>
            <div *ngIf="f.url === '/files/undefined'" style="color:#ff3333">file error: corrupt data !</div>
          </ng-container>
          
          <button *ngIf="moveToText" class="ml-3 nrk-button" style="position:relative;top:-0.25rem;font-size:50%" (click)="moveTo.emit(i)">{{moveToText}}</button>
          <div *ngIf="!hideComment">
            <div class="row ml-2" style="font-size:10pt" *ngIf="descriptionOptions">
              <div>select:&nbsp;</div>
              <div>
                <select (change)="f.comment=$any($event?.target)?.value">
                  <option *ngFor="let opt of descriptionOptions" [ngValue]="opt">{{opt}}</option>
                </select>                
              </div>
            </div>
            <input type="text" class="comment form-control-sm" placeholder="description" [ngModel]="f.comment || ''" (ngModelChange)="f.comment=$event;completed.emit()">
          </div>
          <div *ngIf="additionalFieldLabel">
            <input type="text" class="comment form-control-sm" [placeholder]="additionalFieldLabel" [ngModel]="f.additionalField || ''" (ngModelChange)="f.additionalField=$event;completed.emit()">
          </div>
          <div *ngIf="additionalDateLabel">
            <!-- <input type="text" class="comment form-control-sm" [placeholder]="additionalDateLabel" [ngModel]="f.additionalDate || ''"  (ngModelChange)="f.additionalDate=$event;completed.emit()"> -->
            <!-- <ngx-form-js-date [title]="additionalDateLabel" [(value)]="$any(f).additionalDate" (valueChange)="completed.emit()"></ngx-form-js-date> -->
            <!-- <ngx-doc-form-date class="comment form-control-sm" [(value)]="$any(f).additionalDate" (valueChange)="$any(f).additionalDate=$event;completed.emit()" [title]="additionalDateLabel"></ngx-doc-form-date> -->
            <ngx-doc-form-date 
              class="form-control-sm" 
              [(value)]="$any(f).additionalDate" 
              (valueChange)="$any(f).additionalDate=$event;completed.emit()" 
              [title]="additionalDateLabel" 
              style="display:block">
            </ngx-doc-form-date>
          </div>
          <div *ngIf="canShowPreview(f)">
            <ngx-thumb-image [imageUrl]="'/api/v1' + f.url"></ngx-thumb-image>
          </div>   
        </td><td>
          <div *ngIf="i === 0" class="moveItemDisabled">▲</div>
          <div *ngIf="i !== 0" class="moveItem" (click)="onMoveFile(i, true)">▲</div>
          <div *ngIf="isLast" class="moveItemDisabled">▼</div>
          <div *ngIf="!isLast" class="moveItem" (click)="onMoveFile(i, false)">▼</div>
        </td></tr>
      </table>
    </div>
  </div>
</div>
